// import React, { useEffect, useRef } from 'react';
// import { Box, Typography, List, ListItem, ListItemIcon, ListItemText, Paper, ListItemButton, Fab, useScrollTrigger, Zoom } from '@mui/material';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import PolicyIcon from '@mui/icons-material/Policy';
// import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// function ScrollTop(props) {
//   const { children } = props;
//   const trigger = useScrollTrigger({
//     disableHysteresis: true,
//     threshold: 100,
//   });

//   const handleClick = (event) => {
//     const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');

//     if (anchor) {
//       anchor.scrollIntoView({
//         behavior: 'smooth',
//         block: 'center',
//       });
//     }
//   };

//   return (
//     <Zoom in={trigger}>
//       <Box
//         onClick={handleClick}
//         role="presentation"
//         sx={{ position: 'fixed', bottom: 32, right: 32, zIndex: 1000 }}
//       >
//         {children}
//       </Box>
//     </Zoom>
//   );
// }

// const Policies = () => {
//   const policyRefs = useRef({});
//   const [activePolicy, setActivePolicy] = React.useState('');

//   useEffect(() => {
//     document.title = 'Policies - ARC Publication Services LLC';

//     // Set up intersection observer to highlight active section
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             setActivePolicy(entry.target.id);
//           }
//         });
//       },
//       { threshold: 0.5, rootMargin: '-100px 0px -50% 0px' }
//     );

//     // Observe all policy sections
//     Object.values(policyRefs.current).forEach(ref => {
//       if (ref) observer.observe(ref);
//     });

//     return () => observer.disconnect();
//   }, []);

//   const scrollToPolicy = (id) => {
//     const element = document.getElementById(id);
//     if (element) {
//       window.scrollTo({
//         top: element.offsetTop - 100,
//         behavior: 'smooth'
//       });
//     }
//   };

//   const policies = [
//     {
//       id: 'ethics-policy',
//       title: 'Ethics Policy',
//       description: 'Arc Publication Services LLC adheres to the Committee on Publication Ethics (COPE) guidelines.',
//       points: [
//         'Authors must submit original work and properly cite sources.',
//         'Plagiarism, duplicate submissions, or manipulated data are strictly prohibited.',
//         'Conflicts of interest must be disclosed by all parties.',
//         'Misconduct may lead to manuscript rejection, article retraction, or reporting to institutions.'
//       ],
//       footer: 'Our editorial team ensures that academic integrity remains at the core of every publication.'
//     },
//     {
//       id: 'open-access-policy',
//       title: 'Open Access Policy',
//       description: 'We are committed to free and universal access to research.',
//       points: [
//         'All articles are published under Creative Commons licenses (CC-BY), ensuring unrestricted use, distribution, and citation.',
//         'Authors retain copyright while granting Arc Publication Services LLC the right to disseminate their work.',
//         'Open access maximizes citations, readership, and academic impact.'
//       ]
//     },
//     {
//       id: 'archiving-policy',
//       title: 'Archiving Policy',
//       description: 'To safeguard research for future generations:',
//       points: [
//         'Articles are preserved in digital repositories and indexed databases.',
//         'Authors are allowed to self-archive accepted manuscripts in institutional repositories.',
//         'We partner with international archiving systems such as LOCKSS, CLOCKSS, and the PKP Preservation Network (PKP|PN), which provides decentralized and secure preservation of content published through Open Journal Systems (OJS).'
//       ]
//     },
//     {
//       id: 'advertising-policy',
//       title: 'Advertising Policy',
//       description: 'Arc Publication Services LLC accepts advertising that aligns with academic and professional values.',
//       points: [
//         'Advertisements are independent from editorial and peer-review decisions.',
//         'Misleading or non-scholarly content is not accepted.',
//         'Sponsored content is clearly identified to maintain transparency.',
//         'Advertising revenue supports our open access model, reducing costs for authors.'
//       ]
//     }
//   ];

//   return (
//     <Box sx={{ 
//       display: 'flex',
//       flexDirection: { xs: 'column', md: 'row' },
//       minHeight: '100vh',
//       backgroundColor: '#f9fafb',
//       pt: { xs: 12, md: 8 },
//       pb: 4,
//       position: 'relative'
//     }}>
//       <div id="back-to-top-anchor" style={{ position: 'absolute', top: 0 }} />
//       {/* Sidebar Navigation */}
//       <Box sx={{
//         width: { xs: '100%', md: '280px' },
//         flexShrink: 0,
//         position: { xs: 'static', md: 'sticky' },
//         top: 80,
//         height: 'fit-content',
//         p: { xs: 2, md: 3 },
//         mb: { xs: 4, md: 0 }
//       }}>
//         <Paper 
//           elevation={2} 
//           sx={{ 
//             p: 2, 
//             borderRadius: 2,
//             backgroundColor: 'white',
//             position: 'sticky',
//             top: 100
//           }}
//         >
//           <Typography variant="h6" sx={{ 
//             mb: 2, 
//             color: '#1976d2',
//             fontWeight: 600,
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1
//           }}>
//             <PolicyIcon color="primary" />
//             Policies
//           </Typography>
//           <List dense>
//             {policies.map((policy) => (
//               <ListItem 
//                 key={policy.id} 
//                 disablePadding
//                 sx={{ 
//                   mb: 0.5,
//                   borderRadius: 1,
//                   backgroundColor: activePolicy === policy.id ? 'rgba(79, 70, 229, 0.1)' : 'transparent',
//                   transition: 'background-color 0.2s'
//                 }}
//               >
//                 <ListItemButton
//                   onClick={() => scrollToPolicy(policy.id)}
//                   selected={activePolicy === policy.id}
//                   sx={{
//                     borderRadius: 1,
//                     '&.Mui-selected': {
//                       backgroundColor: 'transparent',
//                       color: '#4f46e5',
//                       fontWeight: 600
//                     },
//                     '&:hover': {
//                       backgroundColor: 'rgba(0, 0, 0, 0.04)'
//                     }
//                   }}
//                 >
//                   <ListItemText 
//                     primary={policy.title} 
//                     primaryTypographyProps={{
//                       variant: 'body2',
//                       fontWeight: activePolicy === policy.id ? 600 : 'normal'
//                     }}
//                   />
//                 </ListItemButton>
//               </ListItem>
//             ))}
//           </List>
//         </Paper>
//       </Box>

//       {/* Main Content */}
//       <Box sx={{ 
//         flex: 1, 
//         py: 4,
//         px: { xs: 2, md: 4 },
//         maxWidth: { md: 'calc(100% - 280px)' }
//       }}>
//         <Box sx={{ maxWidth: '1000px', mx: 'auto' }}>
//           {policies.map((policy, index) => (
//             <Box 
//               key={policy.id}
//               id={policy.id}
//               ref={el => policyRefs.current[policy.id] = el}
//               sx={{ 
//                 mb: 8,
//                 backgroundColor: 'white',
//                 borderRadius: 2,
//                 boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)',
//                 overflow: 'hidden',
//                 position: 'relative',
//                 transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//                 '&:hover': {
//                   transform: 'translateY(-4px)',
//                   boxShadow: '0 8px 25px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.15)'
//                 },
//                 '&::before': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   bottom: 0,
//                   background: 'linear-gradient(rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%), url("data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' viewBox=\'0 0 100 100\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z\' fill=\'%239C92AC\' fill-opacity=\'0.1\' fill-rule=\'evenodd\'/%3E%3C/svg%3E")',
//                   opacity: 0.5,
//                   zIndex: 0,
//                   pointerEvents: 'none'
//                 },
//                 '&:last-child': { 
//                   mb: 0 
//                 }
//               }}
//             >
//               <Box sx={{ 
//                 position: 'relative',
//                 zIndex: 1,
//                 p: { xs: 3, md: 4 }, 
//                 borderBottom: '1px solid #e2e8f0',
//                 backgroundColor: 'rgba(255, 255, 255, 0.6)'
//               }}>
//                 <Typography 
//                   variant="h4" 
//                   component="h2" 
//                   sx={{ 
//                     color: '#1976d2', 
//                     mb: 2,
//                     fontSize: '1.5rem',
//                     fontWeight: 600,
//                     scrollMarginTop: '100px' // Add space for fixed header
//                   }}
//                 >
//                   {policy.title}
//                 </Typography>
//                 <Typography variant="body1" sx={{ color: '#4a5568', mb: 2 }}>
//                   {policy.description}
//                 </Typography>
//               </Box>
//               <Box sx={{ p: { xs: 3, md: 4 }, pt: 2 }}>
//                 <List disablePadding>
//                   {policy.points.map((point, idx) => (
//                     <ListItem key={idx} disableGutters sx={{ alignItems: 'flex-start', py: 1 }}>
//                       <ListItemIcon sx={{ minWidth: 32, mt: '4px' }}>
//                         <CheckCircleIcon color="primary" sx={{ fontSize: '1.25rem' }} />
//                       </ListItemIcon>
//                       <ListItemText 
//                         primary={point} 
//                         primaryTypographyProps={{ 
//                           variant: 'body1',
//                           color: 'text.secondary',
//                           sx: { lineHeight: 1.6 }
//                         }} 
//                       />
//                     </ListItem>
//                   ))}
//                 </List>
//                 {policy.footer && (
//                   <Typography variant="body1" sx={{ mt: 3, color: '#4a5568', fontStyle: 'italic' }}>
//                     {policy.footer}
//                   </Typography>
//                 )}
//               </Box>
//             </Box>
//           ))}
//         </Box>
//       </Box>
//       <ScrollTop>
//         <Fab color="primary" size="medium" aria-label="scroll back to top" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
//           <KeyboardArrowUpIcon />
//         </Fab>
//       </ScrollTop>
//     </Box>
//   );
// };

// export default Policies;

import React, { useEffect, useRef } from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText, Paper, ListItemButton, Fab, useScrollTrigger, Zoom } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PolicyIcon from '@mui/icons-material/Policy';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

function ScrollTop(props) {
  const { children } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');

    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  return (
    <Zoom in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: 'fixed', bottom: 32, right: 32, zIndex: 1000 }}
      >
        {children}
      </Box>
    </Zoom>
  );
}

const Policies = () => {
  const policyRefs = useRef({});
  const [activePolicy, setActivePolicy] = React.useState('');

  useEffect(() => {
    document.title = 'Policies - ARC Publication Services LLC';

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setActivePolicy(entry.target.id);
          }
        });
      },
      { threshold: 0.5, rootMargin: '-100px 0px -50% 0px' }
    );

    Object.values(policyRefs.current).forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  const scrollToPolicy = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 100,
        behavior: 'smooth'
      });
    }
  };

  const linkStyle = { color: 'blue', textDecoration: 'underline' };

  const policies = [
    {
      id: 'ethics-policy',
      title: 'ETHICS POLICY',
      description: (
        <>
          The Scientific Reputation of Arc Publication Services LLC is taken very seriously and all members of our publication processes (authors, reviewers, editors and publishers) are carefully monitored for compliance with ethical standards. Our activities are guided by the recommendations of the following editorial organizations:
          <br />
          <a href="https://publicationethics.org/" style={linkStyle}>Committee on Publication Ethics (COPE)</a>
          <br />
          <a href="https://www.wame.org/" style={linkStyle}>World association of medical editors (WAME)</a>
          <br />
          <a href="http://www.icmje.org/about.html" style={linkStyle}>International Committee of Medical Journal Editors (ICMJE)</a>
        </>
      ),
      points: [
        'Any of their financial or other types of conflicts of interest that are likely to affect the results or interpretation of their manuscript should be declared by all the authors. Conflicts of interests emerge in the case of existence of any personal interest in order to distort the authenticity of the information in the manuscript.',
        'Arc Publication Services LLC is not a patron of plagiarism. Authors should ensure that the work that is submitted is entirely original and has not been published before in any language and has not been submitted to another journal to undergo a peer review. Any information that has been borrowed in other publications should have the correct reference to its source.',
        'Any manipulation of scientific data, tables, figures or any text to knowingly give false information to manipulate the process of peer review is forbidden. The authors ensure that all individuals who are included in the list of authors have made a substantial contribution to the process of the work with the article and none of those who have made a substantial contribution is left out of the list of the authors. All sources of external financing should be indicated. All the information in the article is attributed to the author.',
        'Reviewers and editors analyze the level of scientificness of the article and its practicality, as well as the adherence to the principles of ethics of scientific publications. The reviewer is to provide the fair evaluation, no matter what kind of personality, gender, social status, religion and nationality the author has. The principles of confidentiality through which peer review process is achieved imply that no one besides authors and reviewers is aware of all the details of the article (terms of submission, content, stages and features of reviewing, comments of the reviewer and the final decision about the possibility of publication).',
        'Arc Publication Services LLC is certain that the success of all scientific activities is discriminated against by any wrongdoing as the fabrication, falsification or plagiarism. The editor will discuss any doubts of potential breach of ethics or plagiarism with the reviewer (first). In case of need, the issue will be brought to the institution where the corresponding scientific work was done.',
        (
          <>
            We assure ourselves that we will do our best to deliver justice to those accused of misconduct as well as those who brought the matter of misconduct to our attention. When any form of bad scientific practice is established after the publication, then the article is said to be disproved. The editors in this instance will apply the <a href="https://publicationethics.org/newsevents/cope%E2%80%99s-retraction-guidelines" style={linkStyle}>COPE regulations of removal of article</a>.
          </>
        ),
        'The editors of the journal study the case and make decisions about the disproof, and the editor-in-chief publishes a disproof notice with explanation of the reason. An article prepared with violations will remain in the public domain for readers, but will be marked as "removed" along with the mark of disproof.'
      ],
      footer: ''
    },
    {
      id: 'open-access-policy',
      title: 'Open Access Policy',
      description: (
        <>
          The Arc Publication Service LLC journals provide fully open-access open access to all journal publications. All manuscripts are instantly available for all users without charging a fee to either authors or readers. The <a href="https://doi.org/10.24318/cope.2019.1.12" style={linkStyle}>Committee on Publication Ethics (COPE)</a> about good practice and openness for science publication is based on the principles of good practice and openness. The larger the variety of locations that authors may publish their manuscript, the better the chances of production of scientific discourse and the better the likelihood the articles will be cited and the more productive the scientific publications will be. Arc Publication Service LLC's published materials are published under a <a href="https://creativecommons.org/course/cc-cert-edu/" style={linkStyle}>Creative Commons Attribution 4.0 International License</a>.
        </>
      ),
      points: [],
      footer: ''
    },
    {
      id: 'archiving-policy',
      title: 'Archiving Policy',
      description: (
        <>
          The journal's digital archives are permanently preserved using a combination of established digital preservation systems such as the <a href="https://pkp.sfu.ca/software/ojs/pkp-pn/" style={linkStyle}>PKP Preservation Network (PKP-PN)</a>, <a href="https://www.lockss.org/" style={linkStyle}>LOCKSS</a> and <a href="https://clockss.org/" style={linkStyle}>CLOCKSS</a> to provide long-term access, security and preservation of all published scholarly materials for future researchers and readers.
        </>
      ),
      points: [],
      footer: ''
    },
    {
      id: 'authors-policy',
      title: 'For Authors',
      description: 'Arc Publication Services LLC uses the copyright terms of Creative Commons for open-access journals. The authors accept the following conditions by publishing an article in our journals:',
      points: [
        (
          <>
            Authors of the article have rights to authorship of their article and give to the edition the right to first publication of the article on a <a href="https://creativecommons.org/course/cc-cert-edu/" style={linkStyle}>Creative Commons Attribution 4.0 International License</a>. It allows others to freely distribute the published article with the obligatory reference to the authors of original works and original publication in this journal.
          </>
        ),
        'In providing the publisher with the material to be published, the authors are giving the editors the rights to guard and use the article and its distinct components. The publisher is able to reprint the article in the press and on the Internet, translate it into every language, import, export to distribute and increase the number of target readers.',
        'The above rights to which authors are entitled pass on to the edition (publisher), an unlimited duration of validity and the territory of all countries of the world.',
        'The authors ensure that they are the only ones who can use the article, which they have submitted to the edition (publisher). The violation of given guarantees by the authors to the third parties is not the responsibility of the edition (the publisher).',
        'The authors have the right to make independent supplementary deals on the non-exclusive publication of their article in its form published in the journal. As an illustration, to put the work in the online storage of the journal or print it in a monograph. There is an urgent need to give a reference to the initial publication of the work in this journal.',
        'The journal policy allows and stimulates the publication of the article in the Internet (in institutional repository or on personal website) by the authors, as it leads to the effective scientific discourse and advantageous influence on efficacy and dynamics of the article citation.',
        'Each journal has the details of a manuscript that should be prepared on its web site'
      ],
      footer: ''
    }
  ];

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      minHeight: '100vh',
      backgroundColor: '#f9fafb',
      pt: { xs: 12, md: 8 },
      pb: 4,
      position: 'relative'
    }}>
      <div id="back-to-top-anchor" style={{ position: 'absolute', top: 0 }} />
      <Box sx={{
        width: { xs: '100%', md: '280px' },
        flexShrink: 0,
        position: { xs: 'static', md: 'sticky' },
        top: 80,
        height: 'fit-content',
        p: { xs: 2, md: 3 },
        mb: { xs: 4, md: 0 }
      }}>
        <Paper
          elevation={2}
          sx={{
            p: 2,
            borderRadius: 2,
            backgroundColor: 'white',
            position: 'sticky',
            top: 100
          }}
        >
          <Typography variant="h6" sx={{
            mb: 2,
            color: '#1976d2',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <PolicyIcon color="primary" />
            Policies
          </Typography>
          <List dense>
            {policies.map((policy) => (
              <ListItem
                key={policy.id}
                disablePadding
                sx={{
                  mb: 0.5,
                  borderRadius: 1,
                  backgroundColor: activePolicy === policy.id ? 'rgba(79, 70, 229, 0.1)' : 'transparent',
                  transition: 'background-color 0.2s'
                }}
              >
                <ListItemButton
                  onClick={() => scrollToPolicy(policy.id)}
                  selected={activePolicy === policy.id}
                  sx={{
                    borderRadius: 1,
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                      color: '#4f46e5',
                      fontWeight: 600
                    },
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                  }}
                >
                  <ListItemText
                    primary={policy.title}
                    primaryTypographyProps={{
                      variant: 'body2',
                      fontWeight: activePolicy === policy.id ? 600 : 'normal'
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Paper>
      </Box>

      <Box sx={{
        flex: 1,
        py: 4,
        px: { xs: 2, md: 4 },
        maxWidth: { md: 'calc(100% - 280px)' }
      }}>
        <Box sx={{ maxWidth: '1000px', mx: 'auto' }}>
          {policies.map((policy, index) => (
            <Box
              key={policy.id}
              id={policy.id}
              ref={el => policyRefs.current[policy.id] = el}
              sx={{
                mb: 8,
                backgroundColor: 'white',
                borderRadius: 2,
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden',
                position: 'relative',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 25px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.15)'
                },
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%), url("data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' viewBox=\'0 0 100 100\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z\' fill=\'%239C92AC\' fill-opacity=\'0.1\' fill-rule=\'evenodd\'/%3E%3C/svg%3E")',
                  opacity: 0.5,
                  zIndex: 0,
                  pointerEvents: 'none'
                },
                '&:last-child': {
                  mb: 0
                }
              }}
            >
              <Box sx={{
                position: 'relative',
                zIndex: 1,
                p: { xs: 3, md: 4 },
                borderBottom: '1px solid #e2e8f0',
                backgroundColor: 'rgba(255, 255, 255, 0.6)'
              }}>
                <Typography
                  variant="h4"
                  component="h2"
                  sx={{
                    color: '#1976d2',
                    mb: 2,
                    fontSize: '1.5rem',
                    fontWeight: 600,
                    scrollMarginTop: '100px'
                  }}
                >
                  {policy.title}
                </Typography>
                <Typography variant="body1" sx={{ color: '#4a5568', mb: 2, whiteSpace: 'pre-wrap' }}>
                  {policy.description}
                </Typography>
              </Box>
              <Box sx={{ p: { xs: 3, md: 4 }, pt: 2 }}>
                <List disablePadding>
                  {policy.points.map((point, idx) => (
                    <ListItem key={idx} disableGutters sx={{ alignItems: 'flex-start', py: 1 }}>
                      <ListItemIcon sx={{ minWidth: 32, mt: '4px' }}>
                        <CheckCircleIcon color="primary" sx={{ fontSize: '1.25rem' }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={point}
                        primaryTypographyProps={{
                          variant: 'body1',
                          color: 'text.secondary',
                          sx: { lineHeight: 1.6 }
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
                {policy.footer && (
                  <Typography variant="body1" sx={{ mt: 3, color: '#4a5568', fontStyle: 'italic' }}>
                    {policy.footer}
                  </Typography>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      <ScrollTop>
        <Fab color="primary" size="medium" aria-label="scroll back to top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </Box>
  );
};

export default Policies;